import { systemDesignContent } from './systemDesign';
import { lldContent } from './lld';
import { csFundamentalsContent } from './csFundamentals';
import { behavioralContent } from './behavioral';
import { getInterviewQuestions } from './interviewQuestions';
import { getDepthEnrichment } from './depthEnrichments';

const BY_TRACK = {
  'system-design': systemDesignContent,
  lld: lldContent,
  'cs-fundamentals': {
    ...csFundamentalsContent,
    // Curriculum uses a distinct id so DBMS "Locks" and concurrency don't collide
    'concurrency-locks': {
      ...(csFundamentalsContent.locks || {}),
      title: 'Concurrency Locks',
      subtitle:
        'How mutexes, monitors, and lock scopes keep multi-threaded code correct — from the application concurrency angle.',
    },
  },
  behavioral: behavioralContent,
};

const hasQa = (article) =>
  !!article?.questions?.length ||
  (article?.blocks || []).some((b) => b.type === 'qa');

/** Merge depth blocks + interview Q&A onto the base article (non-mutating). */
export const getTopicArticle = (trackId, topicId) => {
  if (!trackId || !topicId) return null;
  const base = BY_TRACK[trackId]?.[topicId];
  if (!base) return null;

  const depth = getDepthEnrichment(trackId, topicId) || [];
  const questions = getInterviewQuestions(trackId, topicId);
  const blocks = [...(base.blocks || [])];

  if (depth.length) {
    blocks.push(...depth);
  }

  if (!hasQa({ ...base, blocks }) && questions?.length) {
    blocks.push({ type: 'qa', items: questions });
  }

  const readingMinutes = Math.max(
    base.readingMinutes || 8,
    Math.min(18, 8 + Math.ceil(blocks.length / 4) + (questions?.length ? 2 : 0)),
  );

  return {
    ...base,
    readingMinutes,
    blocks,
    questions: base.questions || questions || undefined,
  };
};

export const hasTopicArticle = (trackId, topicId) =>
  !!BY_TRACK[trackId]?.[topicId];
